import { z } from 'zod'
import type {
  PriceIntentCreateMutationVariables,
  PriceIntentDataUpdateMutationVariables,
  PriceIntentQuery,
} from '@/services/graphql/generated'
import type { PriceTemplate } from '@/services/PriceCalculator/PriceCalculator.types'

export type PriceIntentCreateParams = PriceIntentCreateMutationVariables & {
  priceTemplate: PriceTemplate
}
export type PriceIntentDataUpdateParams = Omit<PriceIntentDataUpdateMutationVariables, 'shopSessionId'>

export type PriceIntent = Exclude<PriceIntentQuery['priceIntent'], null | undefined>

export const priceIntentAttributionSchema = z.object({
  attributedTo: z.string().optional(),
  initiatedFrom: z.string().optional(),
  userFlow: z.string().optional(),
  flowSource: z.string().optional(),
  experiments: z.array(z.object({ name: z.string(), variant: z.string() })).optional(),
  trackingData: z.unknown().optional(),
})

export type PriceIntentAttribution = z.infer<typeof priceIntentAttributionSchema>
